import { searchDispatch } from "PFReducers/search_reducer/search_reducer";

export const mainDispatch = (dispatch, store) => (action) => {
  const dispatchers = [searchDispatch];

  for (let i = 0; i < dispatchers.length; i++) {
    const result = dispatchers[i](dispatch, action, store);
    if (result) {
      return result;
    }
  }

  return dispatch(action);
};
